import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=b7af8bc4&scoped=true"
import script from "./translation.vue?vue&type=script&lang=js"
export * from "./translation.vue?vue&type=script&lang=js"
import style0 from "./translation.vue?vue&type=style&index=0&id=b7af8bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7af8bc4",
  null
  
)

export default component.exports